<div class="coverPagePicker" (click)="toggleValue()">
  <pp-checkbox ppType="solid" [ppChecked]="ppIncludeCoverPage"></pp-checkbox>

  {{ 'include_cover_page' | ppTranslate }}
</div>
